const favoritesSet = new Set<number>();
const deletedFavoritesSet = new Set<number>();

export function useFavorites() {
  return favoritesSet;
}

export function useDeletedFavorites() {
  return deletedFavoritesSet;
}